<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
  </section>
</template>
<script>
import {
  getVehicleAccidentInfo,
} from 'api/car';
import {
  getEnumList,
} from 'api';
export default {
  components: {
  },
  data () {
    return {
      title: '查看事故详情',
      // 责任归属
      accidentResponsibilityMap: {},
      loading: false,
      detailData: {},
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    // 设置详情
    async setDetailDataShow (detailRes) {
      // 初始化模块，默认有【车辆信息】和【事故登记】
      this.detailData = {
        base: {
          label: '车辆信息',
          tableData: {
            title: [
              { prop: 'plateNumber', label: '车牌号码' },
              { prop: 'orgName', label: '车辆归属' },
              { prop: 'brandModel', label: '品牌名称' },
              { prop: 'brandModelExt', label: '品牌型号' },
              { prop: 'insuranceCompany', label: '保险公司' },
              { prop: 'insuranceUserName', label: '被保险人' },
              { prop: 'insuranceStartDate', label: '起保日期' },
              { prop: 'insuranceEndDate', label: '终保日期' },
              { prop: 'insuranceNumber', label: '保单号' },
              { prop: 'addInsuranceInfo', label: '保险信息' },
            ],
            data: {},
            approveData: {},
          },
        },
        accident: {
          label: '事故登记',
          tableData: {
            title: [
              { prop: 'reportTime', label: '报案日期' },
              { prop: 'accidentTime', label: '出险日期' },
              { prop: 'accidentType', label: '事故类型' },
              { prop: 'accidentAddress', label: '事故地点' },
              { prop: 'accidentDriver', label: '事故司机' },
              { prop: 'accidentPassing', label: '事故经过' },
              { prop: 'accidentRemark', label: '出险原因' },
              { prop: 'accidentResponsibilityName', label: '责任归属' },
              { prop: 'vehicleAccidentPicFileList', label: '事故图片' },
              { prop: 'vehicleAccidentSurePicFileList', label: '事故认定书' },
            ],
            data: {},
            approveData: {},
          },
        },
      };
      if (detailRes.accidentState > 1) {
        // 显示定损模块
        this.detailData.loss = {
          label: '事故定损',
          tableData: {
            title: [
              { prop: 'isVehicleDamageName', label: '本车车损' },
              { prop: 'lossAmt', label: '我方损失金额' },
              { prop: 'isOtherAccidentName', label: '对方车损' },
              { prop: 'otherLossAmt', label: '对方损失金额' },
              { prop: 'isGoodsDamageName', label: '是否物损' },
              { prop: 'isRoadDamageName', label: '道路损' },
              { prop: 'isWoundingName', label: '人伤标志' },
              // { prop: 'vehicleAccidentLossAssessmentFileIds', label: '定损单图片' },
            ],
            data: {},
            approveData: {},
          },
        };
      }
      if (detailRes.accidentState > 2 && detailRes.maintailState === 1) {
        // 显示维修模块
        this.detailData.maintain = {
          label: '维修信息',
          tableData: {
            title: [
              { prop: 'repairServiceName', label: '维修服务商' },
              { prop: 'repairServiceAddress', label: '维修地点' },
              { prop: 'repairServiceTel', label: '联系方式' },
              { prop: 'repairServiceAmt', label: '维修金额' },
              { prop: 'isRepairCompleteName', label: '是否完结' },
            ],
            data: {},
            approveData: {},
          },
        };
      }
      if (detailRes.accidentState === 4) {
        // 显示核赔模块
        this.detailData.claim = {
          label: '核赔信息',
          tableData: {
            title: [
              { prop: 'settAmt', label: '核赔金额' },
              { prop: 'compensationDate', label: '核赔日期' },
              { prop: 'isClosingCaseName', label: '是否结案' },
              { prop: 'closingCaseDate', label: '结案时间' },
              { prop: 'settAccount', label: '核赔账户' },
            ],
            data: {},
            approveData: {},
          },
        };
      }
    },
    // 通过value值找到对应的中文
    findLabelByValue (enumsList, value) {
      let retValue = '--';
      for (let item of enumsList) {
        if (`${item.value}` === `${value}`) {
          retValue = item.label;
        }
      }
      return retValue;
    },
    // 设置图片展示
    setImgShow ({ detailRes, fieldName, detailDataName, label }) {
      const imgList = detailRes[fieldName];
      if (imgList && imgList.length) {
        for (let i = 0; i < imgList.length; i++) {
          this.detailData[detailDataName].tableData.title.push({
            prop: `${fieldName}` + i,
            label: label + (i || ''),
            type: 'img',
          });
          detailRes[`${fieldName}` + i] = imgList[i].fileUrl;
        }
      } else {
        this.detailData[detailDataName].tableData.title.push({
          prop: `${fieldName}`,
          label: label,
          type: 'img',
        });
      }
    },
    // 设置车辆信息详情内容
    setBaseDetail (detailRes, enumsList) {
      this.detailData.base.tableData.data = detailRes;
      if (detailRes.vehicle) {
        this.detailData.base.tableData.data.orgName = detailRes.vehicle.orgName;
        this.detailData.base.tableData.data.brandModel = detailRes.vehicle.brandModel;
        this.detailData.base.tableData.data.brandModelExt = detailRes.vehicle.brandModelExt;
      }
      if (!detailRes.accidentResponsibilityName) {
        this.detailData.base.tableData.data.accidentResponsibilityName = this.findLabelByValue(enumsList, detailRes.accidentResponsibility);
      }
    },
    // 设置事故登记详情内容
    setAccidentDetail (detailRes) {
      const insertIndex = this.detailData.accident.tableData.title.findIndex((item) => item.prop === 'accidentResponsibilityName') + 1;
      this.detailData.accident.tableData.title.length = insertIndex;
      this.setImgShow({
        detailRes,
        fieldName: 'vehicleAccidentPicFileList',
        detailDataName: 'accident',
        label: '事故图片',
      });
      this.setImgShow({
        detailRes,
        fieldName: 'vehicleAccidentSurePicFileList',
        detailDataName: 'accident',
        label: '事故认定书',
      });
      this.detailData.accident.tableData.data = detailRes;
    },
    // 设置事故定损详情内容
    setLossDetail (detailRes) {
      if (this.detailData.loss) {
        this.detailData.loss.tableData.data = detailRes;
        const insertIndex = this.detailData.loss.tableData.title.findIndex((item) => item.prop === 'isWoundingName') + 1;
        this.detailData.loss.tableData.title.length = insertIndex;
        this.setImgShow({
          detailRes,
          fieldName: 'vehicleAccidentLossAssessmentFileIds',
          detailDataName: 'loss',
          label: '定损单图片',
        });
      }
    },
    // 设置维修信息详情
    setMaintainDetail (detailRes) {
      if (this.detailData.maintain) {
        const insertIndex = this.detailData.maintain.tableData.title.findIndex((item) => item.prop === 'isRepairCompleteName') + 1;
        this.detailData.maintain.tableData.title.length = insertIndex;
        this.detailData.maintain.tableData.data = detailRes;
        this.setImgShow({
          detailRes,
          fieldName: 'vehicleAccidentRepairPicFileList',
          detailDataName: 'maintain',
          label: '维修清单',
        });
        this.setImgShow({
          detailRes,
          fieldName: 'vehicleAccidentRepairCompPicFileList',
          detailDataName: 'maintain',
          label: '完结图片',
        });
      }
    },
    // 设置核赔信息详情
    setClaimDetail (detailRes) {
      if (this.detailData.claim) {
        this.detailData.claim.tableData.data = detailRes;
      }
    },
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/accident/detail') {
        return;
      }
      this.loading = true;
      const enumsList = await getEnumList({
        codeType: 'SHARE_FLG,RESPONSIBILITY_ATTRIBUTION',
      });
      const detailRes = await getVehicleAccidentInfo({
        id: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.setDetailDataShow(detailRes);
        this.setBaseDetail(detailRes, enumsList[1]);
        this.setAccidentDetail(detailRes);
        this.setLossDetail(detailRes);
        this.setMaintainDetail(detailRes);
        this.setClaimDetail(detailRes);
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
